import moment from "moment";
import { API_DATE_FORMAT } from "@/constants/common";

export const hourAndMinutesFilter = date => {
  return moment(date, API_DATE_FORMAT).format("HH:mm");
};
